import { useContext, useEffect, useMemo } from "react";
import getConfig from "../configs/tableConfig";
import { Card } from "react-bootstrap";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "../../auth/AuthContext";
import useListAction from "../actions/list/useListAction";
import useCreateAction from "../actions/create/useCreateAction";
import useEditAction from "../actions/edit/useEditAction";
import useRemoveAction from "../actions/remove/useRemoveAction";
import { t } from "i18next";
import useExportAction from "@beeldit/user-and-access/users/actions/export/useExportAction";
import useChangePasswordAction from "@beeldit/user-and-access/users/actions/change-password/useChangePasswordAction";
import useResetPasswordMailAction from "@beeldit/user-and-access/users/actions/reset-password-mail/useResetPasswordMailAction";
import useActiveOrDisableAccountAction from "@beeldit/user-and-access/users/actions/active-or-disable-account/useActiveOrDisableAccountAction";

function UserPage(props: any) {
  const { filters, formDefaultValues } = props;
  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction, formDefaultValues);

  const { getFunction, actionTemplate: editActionTemplate } =
    useEditAction(indexFunction);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  const { exportFunction, actionTemplate: exportActionTemplate } =
    useExportAction(filters);

  // Change password modal
  const {
    actionTemplate: changePasswordModal,
    prepareChangePasswordFunction,
  } = useChangePasswordAction();

  // Reset password email modal
  const {
    prepareResetPasswordFunction,
    actionTemplate: resetPasswordTemplate,
  } = useResetPasswordMailAction();

  // Activate/Disable account modal
  const {
    prepareActiveOrDisableFunction,
    actionTemplate: activeOrDisableTemplate,
  } = useActiveOrDisableAccountAction(indexFunction);

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getConfig({
        initializeFunction,
        indexFunction,
        getFunction,
        prepareRemoveFunction,
        exportFunction,
        prepareChangePasswordFunction,
        prepareResetPasswordFunction,
        prepareActiveOrDisableFunction,
        /**newActionsTableConfig**/
      }),
    [
      initializeFunction,
      indexFunction,
      getFunction,
      prepareRemoveFunction,
      exportFunction,
      prepareChangePasswordFunction,
      prepareResetPasswordFunction,
      prepareActiveOrDisableFunction,
    ]
  );
  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);
  return (
    <Card>
      <Card.Header>
        <span>{t("users")}</span>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {editActionTemplate}
        {removeActionTemplate}
        {exportActionTemplate}
        {changePasswordModal}
        {resetPasswordTemplate}
        {activeOrDisableTemplate}
      </Card.Body>
    </Card>
  );
}

export default UserPage;
